import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-cities/page.tsx");
